import AsyncStorage from '@react-native-async-storage/async-storage';
import * as React from 'react';

const PULSE_SWIPE_HINT_SEEN_KEY = 'radious:pulse-swipe-hint-seen:v1';

export function usePulseSwipeHint() {
  const [isReady, setIsReady] = React.useState(false);
  const [shouldShow, setShouldShow] = React.useState(false);

  React.useEffect(() => {
    let cancelled = false;

    AsyncStorage.getItem(PULSE_SWIPE_HINT_SEEN_KEY)
      .then((value) => {
        if (cancelled) {
          return;
        }
        setShouldShow(value !== 'true');
      })
      .catch(() => {
        if (!cancelled) {
          setShouldShow(false);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setIsReady(true);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const markSeen = React.useCallback(() => {
    setShouldShow(false);
    AsyncStorage.setItem(PULSE_SWIPE_HINT_SEEN_KEY, 'true').catch(() => undefined);
  }, []);

  return {
    markSeen,
    shouldShow: isReady && shouldShow,
  };
}
